import React from 'react'

import { Routes } from './routes'

import { NavigationItem } from '../types/navigation'

import { ReactComponent as ClipboardTickSBIcon } from '../../assets/icons/clipboard-tick.svg'
import { ReactComponent as HomeSBIcon } from '../../assets/icons/grid.svg'
import { ReactComponent as CalendarSBIcon } from '../../assets/icons/group-39654.svg'
import { ReactComponent as ListSBIcon } from '../../assets/icons/action-item.svg'
import { ReactComponent as MessageSBIcon } from '../../assets/icons/vector-1.svg'
import { ReactComponent as UsersSBIcon } from '../../assets/icons/ion_people-outline.svg'
import { ReactComponent as StarSBIcon } from '../../assets/icons/star.svg'
import { ReactComponent as DollarSignSBIcon } from '../../assets/icons/dollar-sign.svg'
import { ReactComponent as ToolSBIcon } from '../../assets/icons/tool.svg'
import { ReactComponent as FileSBIcon } from '../../assets/icons/file.svg'

import AlarmIcon from '@material-ui/icons/Alarm'
import BusinessIcon from '@material-ui/icons/Business'
import HomeIcon from '@material-ui/icons/Home'
import PeopleIcon from '@material-ui/icons/People'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import BubbleChartIcon from '@material-ui/icons/BubbleChart'
import PaymentIcon from '@material-ui/icons/Payment'
import AssessmentIcon from '@material-ui/icons/Assessment'
import MailIcon from '@material-ui/icons/Mail'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import ApartmentIcon from '@material-ui/icons/Apartment'
import SchoolIcon from '@material-ui/icons/School'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import FilterNoneIcon from '@material-ui/icons/FilterNone'
import NotificationsIcon from '@material-ui/icons/Notifications'

import CompareIcon from '@material-ui/icons/Compare'
import Assignment from '@material-ui/icons/Assignment'
import DoneAll from '@material-ui/icons/DoneAll'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import TableChartOutlined from '@material-ui/icons/TableChartOutlined'
import { VIEW_INVOICE } from '../../models'
import { ReceiptOutlined } from '@material-ui/icons'
import Receipt from '@material-ui/icons/Receipt'
import Settings from '@material-ui/icons/Settings'
import Help from '@material-ui/icons/Help'
import Apps from '@material-ui/icons/Apps'

import DomainIcon from '@material-ui/icons/Domain'
import MoveOutIcon from '@material-ui/icons/MoveToInbox'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import RateReviewIcon from '@material-ui/icons/RateReview'

import { LoriIcon } from '../layouts/Lori/Icons/LoriIcon'
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter'
import EventNoteIcon from '@material-ui/icons/EventNote'
import LanguageIcon from '@material-ui/icons/Language'
import PhoneIcon from '@material-ui/icons/Phone'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import FormsPendingBadge from '../../components/FormsPendingBadge'
import VendorInvoiceRequestBadge from '../../components/VendorInvoiceRequestBadge'

export const navigationConfig: NavigationConfig = {
    apartment: {
        mainItems: [
            {
                link: Routes.apartment.schedule.root,
                icon: <CalendarSBIcon />,
                name: 'Scheduler',
            },
            {
                link: Routes.apartment.inspection.root,
                icon: <ClipboardTickSBIcon />,
                name: 'Inspection',
            },
            {
                link: Routes.apartment.jobBoard,
                icon: <TableChartOutlined fontSize="large" />,
                name: 'Job Board',
            },
            {
                link: Routes.apartment.actionItems,
                icon: <ListSBIcon height={32} width={32} />,
                name: 'Action Items',
            },
            {
                link: Routes.public.nvl.root,
                icon: <StarSBIcon />,
                name: 'National Vendors List',
            },
            {
                link: Routes.apartment.rfp.rfpDashboard,
                icon: <RateReviewIcon fontSize="large" />,
                name: 'RFP',
            },
            {
                link: Routes.shared.workforce,
                icon: <UsersSBIcon />,
                name: 'Workforce',
            },
            {
                link: Routes.apartment.lease.root,
                icon: <FileSBIcon />,
                name: 'Leases',
            },
            // {
            //     link: Routes.apartment.lease.audit,
            //     icon: <CompareIcon fontSize="large" />,
            //     name: 'Lease Audit',
            // },
            {
                link: Routes.shared.communication.ezchat,
                icon: <MessageSBIcon />,
                name: 'Chat',
            },
            {
                // TODO: change this to the correct route
                link: Routes.apartment.config.damage,
                icon: <ToolSBIcon />,
                name: 'Damages',
            },
            {
                link: Routes.shared.financial.invoiceHome,
                icon: <DollarSignSBIcon />,
                name: 'Finances',
            },
            {
                link: Routes.apartment.config.propertyAutomation,
                icon: <BubbleChartIcon fontSize="large" />,
                name: 'Property Automation',
            },
            {
                link: Routes.apartment.units.root,
                icon: <ApartmentIcon fontSize="large" />,
                name: 'Units',
            },
            {
                link: Routes.apartment.inventoryManagement.root,
                icon: <Assignment fontSize="large" />,
                name: 'Inventory Management (Beta)',
            },
        ],
        footerItems: [],
    },
    vendor: {
        mainItems: [
            {
                link: Routes.vendor.ezwork,
                icon: <Assignment fontSize="large" />,
                name: 'EZWork',
            },
            {
                link: Routes.vendor.subs,
                icon: <DoneAll fontSize="large" />,
                name: 'View subs',
                navLabel: 'Subs',
            },
            {
                link: Routes.shared.workforce,
                icon: <PeopleIcon fontSize="large" />,
                name: 'Workforce',
            },
            {
                link: Routes.shared.financial.invoiceHome,
                icon: (
                    <VendorInvoiceRequestBadge>
                        <Receipt fontSize="large" />
                    </VendorInvoiceRequestBadge>
                ),
                name: 'Invoice',
                requiredPermissions: [VIEW_INVOICE],
            },
            {
                link: Routes.vendor.projectAnalytics,
                icon: <AssessmentIcon fontSize="large" />,
                name: 'Analytics',
            },
            {
                link: Routes.vendor.nationalPropertyList,
                icon: <Apps fontSize="large" />,
                name: 'National Property List',
                navLabel: 'NPL',
                requiredPremium: true,
            },
        ],
        footerItems: [
            {
                link: Routes.vendor.settings,
                icon: <Settings fontSize="large" />,
                name: 'Settings',
            },
            {
                link: Routes.vendor.help,
                icon: <Help fontSize="large" />,
                name: 'Help',
            },
        ],
    },
    shared: {
        mainItems: [
            {
                link: Routes.shared.financial.invoiceList,
                icon: <ReceiptOutlined fontSize="large" />,
                name: 'Invoice',
                requiredPermissions: [VIEW_INVOICE],
            },
        ],
        footerItems: [],
    },
    organization: {
        mainItems: [
            // {
            //     link: Routes.organization.root,
            //     icon: <HomeSBIcon />,
            //     name: 'Dashboard',
            // },
            {
                link: Routes.organization.jobBoard,
                icon: <TableChartOutlined fontSize="large" />,
                name: 'Job Board',
            },
            // {
            //     link: Routes.organization.directory,
            //     icon: <PeopleIcon fontSize="large" />,
            //     name: 'Directory',
            // },
            {
                link: Routes.organization.projects,
                icon: <AssignmentTurnedInIcon fontSize="large" />,
                name: 'Projects',
            },
            {
                link: Routes.organization.workforce,
                icon: <PeopleIcon fontSize="large" />,
                name: 'Workforce',
            },
            {
                link: Routes.organization.rfp.rfpDashboard,
                icon: <RateReviewIcon fontSize="large" />,
                name: 'RFP',
            },
            {
                link: Routes.organization.facilities,
                icon: <ListSBIcon style={{ height: 32, width: 32 }} />,
                name: 'Facilities',
            },
            {
                link: Routes.organization.damages,
                icon: <ToolSBIcon />,
                name: 'Damages',
            },
            {
                link: Routes.organization.invoiceHome,
                icon: <DollarSignSBIcon />,
                name: 'Finances',
            },
            {
                link: Routes.organization.propertyForms,
                icon: <FileCopyIcon fontSize="large" />,
                name: 'Add/Remove Properties',
            },
            {
                link: Routes.organization.properties,
                icon: <DomainIcon fontSize="large" />,
                name: 'Properties',
            },
            {
                link: Routes.organization.propertyAudit.root,
                icon: <AssessmentIcon fontSize="large" />,
                name: 'Audits & Reports',
            },
            {
                link: Routes.organization.deadlines,
                icon: <AlarmIcon fontSize="large" />,
                name: 'Deadlines',
            },
            {
                link: Routes.organization.contractManager,
                icon: <BusinessCenterIcon fontSize="large" />,
                name: 'Contract Manager',
            },
            {
                link: Routes.organization.copyTool,
                icon: <CompareIcon fontSize="large" />,
                name: 'Copy Tool',
            },
            {
                link: Routes.organization.moveInSurvey,
                icon: <RateReviewIcon fontSize="large" />,
                name: 'Survey Results',
            },
        ],
        footerItems: [],
    },
    admin: {
        mainItems: [
            {
                link: Routes.admin.organization.list,
                icon: <BusinessIcon fontSize="large" />,
                name: 'Organizations',
            },
            {
                link: Routes.admin.properties.root,
                icon: <HomeIcon fontSize="large" />,
                name: 'Properties',
            },
            {
                link: Routes.admin.users.root,
                icon: <PeopleIcon fontSize="large" />,
                name: 'Users',
            },
            {
                link: Routes.admin.vendors.root,
                icon: <HomeSBIcon fontSize="large" />,
                name: 'Vendors',
            },
            {
                link: Routes.admin.schools.root,
                icon: <SchoolIcon fontSize="large" />,
                name: 'Schools',
            },
            {
                link: Routes.admin.invoices.root,
                icon: <AttachMoneyIcon fontSize="large" />,
                name: 'Invoices',
            },
            {
                link: Routes.admin.billingGroups,
                icon: <PaymentIcon fontSize="large" />,
                name: 'Billing Groups',
            },
            {
                link: Routes.admin.loriManager,
                icon: <LoriIcon width={24} height={24} color={'#f4f7f6'} />,
                name: 'Lori Manager',
            },
            {
                link: Routes.admin.supportTicket,
                icon: <ConfirmationNumberIcon />,
                name: 'Support Tickets',
            },
            {
                link: Routes.admin.kpi,
                icon: <AssessmentIcon />,
                name: 'KPI',
            },
            {
                link: Routes.admin.forms,
                icon: (
                    <FormsPendingBadge>
                        <FileCopyIcon fontSize="large" />
                    </FormsPendingBadge>
                ),
                name: 'Forms',
            },
            {
                link: Routes.admin.reports,
                icon: <AssessmentIcon />,
                name: 'Reports',
            },
            {
                link: Routes.admin.outreach,
                icon: <EventNoteIcon fontSize="large" />,
                name: 'Leasing Season',
            },
            {
                link: Routes.admin.applicationAccess,
                icon: <AccountBoxIcon fontSize="large" />,
                name: 'Application',
            },
            {
                link: Routes.admin.onboardApartment,
                icon: <AddCircleIcon fontSize="large" />,
                name: 'Onboard',
            },
            {
                link: Routes.admin.copyConfigs,
                icon: <FilterNoneIcon fontSize="large" />,
                name: 'Copy Configs',
            },
            {
                link: Routes.admin.workspaceManager,
                icon: <SupervisedUserCircleIcon fontSize="large" />,
                name: 'Workspaces',
            },
            {
                link: Routes.admin.bannerNotifications,
                icon: <NotificationsIcon fontSize="large" />,
                name: 'Banners',
            },
        ],
        footerItems: [],
    },
    manage: {
        mainItems: [
            {
                link: Routes.manage.propertyEvents.root,
                icon: <CalendarTodayIcon fontSize="large" />,
                name: 'Calendar',
            },
            {
                link: Routes.manage.leasingSeason.root,
                icon: <EventNoteIcon fontSize="large" />,
                name: 'Leasing Season',
            },
            {
                link: Routes.manage.webTools,
                icon: <LanguageIcon fontSize="large" />,
                name: 'Web Tools',
            },
            {
                link: Routes.manage.voiceAgent.root,
                icon: <PhoneIcon fontSize="large" />,
                name: 'Voice Agent',
            },
            {
                link: Routes.manage.lease.root,
                icon: <FileSBIcon />,
                name: 'Leases',
            },
            {
                link: Routes.manage.lease.audit,
                icon: <CompareIcon fontSize="large" />,
                name: 'Lease Audit',
            },
            {
                link: Routes.manage.propertyAudit.root,
                icon: <AssessmentIcon fontSize="large" />,
                name: 'Property Audit',
            },
            {
                link: Routes.manage.rent.root,
                icon: <ReceiptOutlined fontSize="large" />,
                name: 'Rent',
            },
            {
                link: Routes.manage.finance.root,
                icon: <DollarSignSBIcon />,
                name: 'Finance',
            },
            {
                link: Routes.manage.contractManager,
                icon: <BusinessCenterIcon fontSize="large" />,
                name: 'Contract Manager',
            },
            {
                link: Routes.manage.moveOutManagement,
                icon: <MoveOutIcon fontSize="large" />,
                name: 'Move Out Management',
            },
            {
                link: Routes.manage.concessions.root,
                icon: <LocalOfferIcon fontSize="large" />,
                name: 'Concessions & Premiums',
            },
            {
                link: Routes.manage.tenantMessages.root,
                icon: <MailIcon fontSize="large" />,
                name: 'Messages',
            },
        ],
        footerItems: [],
    },
}

type NavigationConfig = {
    apartment: {
        mainItems: NavigationItem[]
        footerItems: NavigationItem[]
    }
    vendor: {
        mainItems: NavigationItem[]
        footerItems: NavigationItem[]
    }
    shared: {
        mainItems: NavigationItem[]
        footerItems: NavigationItem[]
    }
    organization: {
        mainItems: NavigationItem[]
        footerItems: NavigationItem[]
    }
    admin: {
        mainItems: NavigationItem[]
        footerItems: NavigationItem[]
    }
    manage: {
        mainItems: NavigationItem[]
        footerItems: NavigationItem[]
    }
}
